import React, { Suspense,useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Logins from '../Auth/Signin';
import Loader from '../Layout/Loader';
import PrivateRoute from './PrivateRoute';
import RouteLayout from './RouteLayout';

const Routers = () => {
  const login = useState(JSON.parse(localStorage.getItem('login')));

  return (
    <>
      <BrowserRouter basename='/'>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path='/' element={<PrivateRoute />}>
              {login ? (
                <>
                  <Route exact path={`${process.env.PUBLIC_URL}`} element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard/default`} />} />
                  <Route exact path={`/`} element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard/default`} />} />
                </>
              ) : (
                ''
              )}
              <Route path='/*' element={<RouteLayout />} />
            </Route>
            <Route exact path={`${process.env.PUBLIC_URL}/login`} element={<Logins />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </>
  );
};

export default Routers;
